// Modules
import React from 'react';
import PropTypes from 'prop-types';
import clamp from 'lodash/clamp';
import floor from 'lodash/floor';
import moment from 'moment';

import { RelativeTime } from 'components/widgets/dates';
import { SHORT_HUMAN_DATE_TIME_FORMAT } from 'constants';
import SVG from 'components/widgets/icons/svg';

export default class TriageTypeStatusBox extends React.Component {
  componentDidMount() {
    this.interval = window.setInterval(() => this.forceUpdate(), 15 * 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.interval);
  }

  render() {
    const { triageItem } = this.props;
    const age = Math.abs(moment(triageItem.createdAt).diff(moment(), 'minutes'));
    const width = clamp(floor(age), 5) * 20;

    return (
      <div className="triage-type-status">
        <div className="age-indicator-square" style={{ width: `${width}%` }}></div>
        { triageItem.type === 'call' && <SVG src="svg/phone.svg" /> }
        { triageItem.type === 'email' && <SVG src="svg/email.svg" /> }
        { triageItem.type === 'monitoringalert' && <SVG src="svg/monitoring-alert.svg" /> }
        <RelativeTime date={triageItem.createdAt} title={moment(triageItem.createdAt).format(SHORT_HUMAN_DATE_TIME_FORMAT)} />
      </div>
    );
  }
}

TriageTypeStatusBox.propTypes = {
  triageItem: PropTypes.object
};



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-type-status-box.js